export default "__VITE_ASSET__CC0ksH0E__"